import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestService } from '../shared/request.service';
import { environment } from '../../../environments/environment';
import { AdminUser, LoginAdminUser, VerifyOtp } from '../../models/adminmanagement/AdminUser';
// import { BaseResponse, PageInfo } from '../../models/CommonResponse';
import { ConstantValues } from '../../common/constant-values';
import { Department } from '../../models/adminmanagement/Department';
import { Region } from '../../models/adminmanagement/Region';
import { AdminRole, AdminRoleClaimn, SelectOption } from '../../models/adminmanagement/AdminRole';
import { Ministry, MinistryOption } from '../../models/adminmanagement/Ministry';
import { CashCollectionPoint } from '../../models/adminmanagement/Cashcollectionpoint';
import { BaseResponse } from '../../models/commonResponse';

@Injectable({
  providedIn: 'root'
})
export class AdminManagementService {

  constructor(private http: HttpClient, private requestService: RequestService) { }

  //#region  preparation
  httpOptions = {
    headers: new HttpHeaders({
      'Content-typ': 'application/json',
      // "Authorization": "Bearer " + this.
    })
  }
  

  baseAPIUrl = environment.baseAPIUrl+ "/" + environment.apiVer;
  //#endregion

  
  //#region User

  getAdminUserDetail(adminUserId:string){
    const msgData = {
      Id: adminUserId,
      VersionNo: environment.appVersion, // need for May Thu side
      MsgID : 'CORB2409000120241031180410004999',
      TimeStamp:  "20241031180410",
      MsgType: ConstantValues.GET_ADMINUSER_LIST,
      InsID: environment.InsID
    }

    const request = this.requestService.createBaseRequest(ConstantValues.GET_ADMINUSER_DETAIL, msgData);

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `adminusers/detail`, msgData, this.httpOptions
    );
  }

  getAdminUsersList(msgData: any) :  any{
    const request = this.requestService.createBaseRequest(ConstantValues.GET_ADMINUSER_LIST, msgData);
    
    msgData.VersionNo = environment.appVersion, // need for May Thu side
    msgData.MsgID = 'CORB2409000120241031180410004999',
    msgData.TimeStamp =  "20241031180410",
    msgData.MsgType = ConstantValues.GET_ADMINUSER_LIST,
    msgData.InsID = environment.InsID

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `adminusers/list`, msgData, this.httpOptions
    );
  }

  // getAdminRolesList(name:string = '') : any {
  //   const msgData = {
  //     Name: name,
  //     // CurrentPageNumber: pageNumber.toString(),
  //     // PageSize: pageSize.toString()
  //   };
  //   const request = this.requestService.createBaseRequest(ConstantValues.GET_ADMINROLE_LIST, msgData);

  //   return this.http.get<BaseResponse<any>>(
  //     this.baseAPIUrl + 'adminrole/list?name=&pageSize=15&currentPageNumber=1' , this.httpOptions
  //   );
  // }

  setUpAdminUser(msgData: any): any {

    msgData.VersionNo = environment.appVersion, // need for May Thu side
    msgData.MsgID = 'CORB2409000120241031180410004999',
    msgData.TimeStamp =  "20241031180410",
    msgData.MsgType = ConstantValues.GET_ADMINUSER_LIST,
    msgData.InsID = environment.InsID

    const request = msgData.Id? 
      this.requestService.createBaseRequest(ConstantValues.UPDATE_ADMINUSER, msgData) : 
      this.requestService.createBaseRequest(ConstantValues.CREATE_ADMINUSER, msgData);

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `adminusers/${msgData.Id? 'update' : 'create'}`, msgData, this.httpOptions
    );
   
  }

  deleteAdminUser(msgData: any): any {

    const request = this.requestService.createBaseRequest(ConstantValues.DELETE_ADMINUSER, msgData);
    msgData.VersionNo = environment.appVersion, // need for May Thu side
    msgData.MsgID = 'CORB2409000120241031180410004999',
    msgData.TimeStamp =  "20241031180410",
    msgData.MsgType = ConstantValues.GET_ADMINUSER_LIST,
    msgData.InsID = environment.InsID
    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + 'adminusers/delete', msgData, this.httpOptions
    );
  }

  resetAdminUser(msgData: any): any {

    // const request = this.requestService.createBaseRequest(ConstantValues.DELETE_ADMINUSER, msgData);
    // msgData.VersionNo = environment.appVersion, // need for May Thu side
    // msgData.MsgID = 'CORB2409000120241031180410004999',
    // msgData.TimeStamp =  "20241031180410",
    // msgData.MsgType = ConstantValues.GET_ADMINUSER_LIST,
    // msgData.InsID = environment.InsID
    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + 'adminusers/resetpassword', msgData, this.httpOptions
    );
  }

  loginAdminUser(msgData:LoginAdminUser){
    msgData.GrantType = "password";
    const request = this.requestService.createBaseRequest(ConstantValues.LOGIN_ADMINUSER, msgData);
    // console.log('login API obj', request)
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + 'adminusers/login', request, this.httpOptions);
  }

  VerifyOtp(msgData:VerifyOtp) {
    msgData.Provider = 'Email';
    const request = this.requestService.createBaseRequest(ConstantValues.VERIFY_OTP_CODE, msgData);

    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + 'adminusers/twofactorverify', request, this.httpOptions);
  }

  refreshToken(refreshToken: string) {
    // const msgData = { RefreshToken : refreshToken};
    // const request = this.requestService.createBaseRequest(ConstantValues.REFRESH_TOKEN, msgData);
    let MsgInfo = {
        VersionNo: environment.appVersion,
        MsgID: 'CORB2409000120241031180410004999',
        TimeStamp: "20241031180410",
        MsgType: ConstantValues.REFRESH_TOKEN,
        InsID: environment.InsID,
        RefreshToken : refreshToken
      }
    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + 'adminusers/refreshtoken', MsgInfo, this.httpOptions);
  }

  resendOtp(msgData: any) {
    const request = this.requestService.createBaseRequest(ConstantValues.RESENT_OTP, msgData);

    return this.http.post<BaseResponse<any>>(this.baseAPIUrl + 'adminusers/resentotp', request, this.httpOptions);
  }

  //#endregion

  //#region role 
  // getAdminRoleListPagination(pageNumber:number, pageSize: number, name: string = '') :  any{
  //   const msgData = {
  //     Name: name,
  //     CurrentPageNumber: pageNumber.toString(),
  //     PageSize: pageSize.toString()
  //   };
  //   const request = this.requestService.createBaseRequest(ConstantValues.GET_ADMINROLE_LIST, msgData);

  //   return this.http.get<BaseResponse<any>>(
  //     this.baseAPIUrl + 'adminrole/list?name=' + name + '&pageSize=' + pageSize + '&currentPageNumber=' + pageNumber, this.httpOptions
  //   );
  // }

   getAdminRoleListPagination(pageNumber:number, pageSize: number, name: string = '') :  any{
    const msgData = {
      Name: name,
      CurrentPageNumber: pageNumber.toString(),
      PageSize: pageSize.toString()
    };
    const request = this.requestService.createBaseRequest(ConstantValues.GET_ADMINROLE_LIST, msgData);

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + 'adminroles/list', msgData, this.httpOptions
    );
  }

  getAdminRoleList() :  any{
    // const request = this.requestService.createBaseRequest(ConstantValues.GET_ADMINROLE_LIST, msgData);

    return this.http.get<BaseResponse<any>>(
      this.baseAPIUrl + 'adminusers/rolelist', this.httpOptions
    );
  }

  getAdminPermissionList() {
    const request = this.requestService.createBaseRequest(ConstantValues.GET_ADMINUSERPERMISSION_LIST, {});

    return this.http.get<BaseResponse<any>>(this.baseAPIUrl + 'adminusers/permissionlist', this.httpOptions);
  }
  
  setUpAdminRole(msgData: AdminRoleClaimn) {
    const request = this.requestService.createBaseRequest(msgData.RoleId? ConstantValues.UPDATE_ADMINROLECLAIM : ConstantValues.CREATE_ADMINROLECLAIM, msgData);

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `adminroles/${msgData.Id? 'update' : 'create'}`, msgData, this.httpOptions
    );
  }

  getAdminRoleDetail(adminRoleId:string){
    const msgData = {
      Id: adminRoleId
    }

    const request = this.requestService.createBaseRequest(ConstantValues.GET_ADMINROLE_DETAIL, msgData);

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `adminroles/detail`, msgData, this.httpOptions
    );
  }

  deletAdminRole(roleId:string){
    const msgData = {
      Id: roleId
    }
    const request = this.requestService.createBaseRequest(ConstantValues.DELETE_ADMINROLE, msgData);
    
    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `adminroles/delete`, msgData, this.httpOptions
    );
  }

  //#endregion

  //#region ministry
  getMinistryList(pageNumber:number = 1, pageSize: number = 10, name: string = '') :  any{
    const msgData = {
      MinistryName: name,
      CurrentPageNumber: pageNumber.toString(),
      PageSize: pageSize.toString()
    };
    const request = this.requestService.createBaseRequest(ConstantValues.GET_MINISTRY_LIST, msgData);

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `ministries/list`, msgData, this.httpOptions
    );
  }

  // getMinistryOptions() :  any{
  //   const request = this.requestService.createBaseRequest(ConstantValues.GET_MINISTRY_OPTIONS, {});

  //   return this.http.post<BaseResponse<any>>(
  //     this.baseAPIUrl + `ministries/listoptions`, request, this.httpOptions
  //   );
  // }
  getPensionGroupDataApi() :  any{
    const request = this.requestService.createBaseRequest(ConstantValues.GET_MINISTRY_OPTIONS, {});

    return this.http.get<BaseResponse<any>>(
      this.baseAPIUrl + `pensions/pensiontype`, this.httpOptions
    );
  }
  

  getMinistryOptions(pensionGroupId: string) :  any{
    const msgData = {
      PensionGroupId: pensionGroupId
    };
    const request = this.requestService.createBaseRequest(ConstantValues.GET_MINISTRY_OPTIONS, {});
    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `ministries/ministryoptions`, msgData , this.httpOptions
    );
  }

  getMinistryDetail(ministryId:string){
    const msgData = {
      Id: ministryId
    }

    const request = this.requestService.createBaseRequest(ConstantValues.GET_MINISTRY_DETAIL, msgData);

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `ministries/detail`, msgData, this.httpOptions
    );
  }

  setUpMinistry(msgData: Ministry) {
    const request = this.requestService.createBaseRequest((msgData.Id && msgData.Id>0)? ConstantValues.UPDATE_MINISTRY : ConstantValues.CREATE_MINISTRY, msgData);

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `ministries/${msgData.Id? 'update' : 'create'}`, msgData, this.httpOptions
    );
  }

  deletMinistry(ministryId:string){
    const msgData = {
      Id: ministryId
    }
    const request = this.requestService.createBaseRequest(ConstantValues.DELETE_MINISTRY, msgData);
    
    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `ministries/delete`, msgData, this.httpOptions
    );
  }
  //#endregion

  //#region department
  getDepartmentList(pageNumber:number = 1, pageSize: number = 10, name: string = '', pensionGroup: string , ministryId: number) :  any{
    const msgData = {
      DepartmentName: name,
      PensionGroup: pensionGroup,
      MinistryId: ministryId ==0? '' : ministryId +'',
      CurrentPageNumber: pageNumber.toString(),
      PageSize: pageSize.toString()
    };
    const request = this.requestService.createBaseRequest(ConstantValues.GET_DEPARTMENT_LIST, msgData);

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `departments/list`, msgData, this.httpOptions
    );
  }

  getDepartmentDetail(departmentId:string){
    const msgData = {
      Id: departmentId,
      VersionNo: environment.appVersion, // need for May Thu side
      MsgID: 'CORB2409000120241031180410004999',
      TimeStamp: "20241031180410",
      MsgType: ConstantValues.GET_ADMINUSER_LIST,
      InsID: environment.InsID
    }

    const request = this.requestService.createBaseRequest(ConstantValues.GET_DEPARTMENT_DETAIL, msgData);

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `departments/detail`, msgData, this.httpOptions
    );
  }

  setUpDepartment(msgData: Department) {
    const request = (msgData.Id && msgData.Id>0)? 
                    this.requestService.createBaseRequest(ConstantValues.UPDATE_DEPARTMENT , msgData):
                    this.requestService.createBaseRequest(ConstantValues.CREATE_DEPARTMENT, msgData);
    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `departments/${(msgData.Id && msgData.Id>0)? 'update' : 'create'}`, msgData, this.httpOptions
    );
  }

  deletDepartment(departmentId:string){
    const msgData = {
      Id: departmentId
    }
    const request = this.requestService.createBaseRequest(ConstantValues.DELETE_DEPARTMENT, msgData);
    
    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `departments/delete`, msgData, this.httpOptions
    );
  }
  //#endregion

  //#region region

  getRegionDetail(regionId:string){
    const msgData = {
      RegionId: regionId
    }

    // const request = this.requestService.createBaseRequest(ConstantValues.GET_REGION_DETAIL, msgData);

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `regions/detail`, msgData, this.httpOptions
    );
  }

  getRegionList(msgData: any) :  any{
    // const request = this.requestService.createBaseRequest(ConstantValues.GET_REGION_LIST, msgData);

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `regions/list`, msgData, this.httpOptions
    );
  }
  
  deletRegion(regionId:string){
    const msgData = {
      RegionId: regionId
    }
    const request = this.requestService.createBaseRequest(ConstantValues.DELETE_REGION, msgData);
    
    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `regions/delete`, msgData, this.httpOptions
    );
  }

  setUpRegion(msgData: Region) {
    const request = (msgData.RegionId)? 
                    this.requestService.createBaseRequest(ConstantValues.UPDATE_REGION , msgData):
                    this.requestService.createBaseRequest(ConstantValues.CREATE_REGION, msgData);
    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `regions/${msgData.RegionId? 'update' : 'create'}`, msgData, this.httpOptions
    );
  }

  getRegionOptions() :  any{
    const request = this.requestService.createBaseRequest(ConstantValues.GET_REGION_OPTIONS, {});

    return this.http.get<BaseResponse<any>>(
      this.baseAPIUrl + 'regions/options', this.httpOptions
    );
  }

  getTSMList() :  any{
    return this.http.get<BaseResponse<any>>(
      this.baseAPIUrl + 'agents/getTSMAgent', this.httpOptions
    );
  }

  //#endregion

  //#region Cash Collection Point

  getCashCollectionDetail(cashCollectionPointId:string){
    const msgData = {
      CashCollectionPointId: cashCollectionPointId
    }

    const request = this.requestService.createBaseRequest(ConstantValues.GET_CASH_COLLECTION_POINT_DETAIL, msgData);

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `cashcollectionpoints/detail`, msgData, this.httpOptions
    );
  }

  getCashCollectionPointList(msgData: any) :  any{
    // const request = this.requestService.createBaseRequest(ConstantValues.GET_CASH_COLLECTION_POINT_LIST, msgData);

    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `cashcollectionpoints/list`, msgData, this.httpOptions
    );
  }

  setUpCashCollectionPoint(msgData: CashCollectionPoint) {
    const request = (msgData.Id)? 
                    this.requestService.createBaseRequest(ConstantValues.UPDATE_CASH_COLLECTION_POINT , msgData):
                    this.requestService.createBaseRequest(ConstantValues.CREATE_CASH_COLLECTION_POINT, msgData);
    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `cashcollectionpoints/${msgData.Id? 'update' : 'create'}`, msgData, this.httpOptions
    );
  }

  deletCashCollectionPoint(cashCollectionPointId:string){
    const msgData = {
      Id: cashCollectionPointId
    }
    const request = this.requestService.createBaseRequest(ConstantValues.DELETE_CASH_COLLECTION_POINT, msgData);
    
    return this.http.post<BaseResponse<any>>(
      this.baseAPIUrl + `cashcollectionpoints/delete`, msgData, this.httpOptions
    );
  }
  //#endregion
}
// import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { Injectable } from '@angular/core';
// import { environment } from '../../environments/environment.development';
// import { AdminUser, LoginAdminUser } from '../models/adminUser';
// import { BaseResponse, PageInfo } from '../models/commonResponse';
// import { AdminRole } from '../models/adminRole';
// import { ConstantValues } from '../common/constant-values';

// @Injectable({
//   providedIn: 'root'
// })
// export class AdminManagementService {

//   httpOptions = {
//     headers: new HttpHeaders({
//       'Content-typ': 'application/json',
//       // "Authorization": "Bearer " + this.
//     })
//   }
  
//   constructor(private http: HttpClient) { }

//   baseAPIUrl = environment.baseAPIUrl+"/" + environment.apiVer;

//   getTimestampUsingIntl(): string {
//     const now = new Date();
//     const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(now);
//     const month = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(now);
//     const day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(now);
//     const hours = new Intl.DateTimeFormat('en', { hour: '2-digit', hour12: false }).format(now);
//     const minutes = new Intl.DateTimeFormat('en', { minute: '2-digit' }).format(now);
//     const seconds = new Intl.DateTimeFormat('en', { second: '2-digit' }).format(now);
  
//     return `${year}${month}${day}${hours}${minutes}${seconds}`;
//   }

//   private createBaseRequest(msgType: string, msgData:any): any{
//     const baseRequest = {
//       MsgInfo: {
//         VersionNo: environment.appVersion,
//         // MsgID: `${environment.InsID}${this.getTimestampUsingIntl()}`,
//         // TimeStamp: this.getTimestampUsingIntl(),
//         MsgId: 'CORB2409000120241031180410004999',
//         TimeStamp: "20241031180410",
//         MsgType: msgType,
//         InsID: environment.InsID
//       },
//       HashValue: "C8fHj/FgRfBLTb5pTsLSmESkhhXhyz5JuUyMbJPs26s="
//     };
//     return { ...baseRequest, MsgData: msgData};
//   }

//   getAdminUserDetail(adminUserId:string){
//     const msgData = {
//       AdminUserId: adminUserId
//     }

//     const request = this.createBaseRequest(ConstantValues.GET_ADMINUSER_DETAIL, msgData);

//     return this.http.post<BaseResponse<AdminUser>>(
//       this.baseAPIUrl + `/adminusers/detail`, request, this.httpOptions
//     );
//   }

//   getAdminUsersList(pageNumber:number = 1, pageSize: number = 10, name: string = '') :  any{
//     const msgData = {
//       Name: name,
//       CurrentPageNumber: pageNumber.toString(),
//       PageSize: pageSize.toString()
//     };
//     const request = this.createBaseRequest(ConstantValues.GET_ADMINUSER_LIST, msgData);

//     // return this.http.post<BaseResponse<any>>(
//       return this.http.post<BaseResponse<AdminUser[]>>(
//       this.baseAPIUrl + `/adminusers/list`, request, this.httpOptions
//     );
//   }

//   getAdminRolesList(name:string = '') : any {
//     const msgData = {
//       Name: name,
//       // CurrentPageNumber: pageNumber.toString(),
//       // PageSize: pageSize.toString()
//     };
//     const request = this.createBaseRequest(ConstantValues.GET_ADMINROLE_LIST, msgData);

//     // return this.http.post<BaseResponse<{PageInfo: PageInfo, AdminRoles: AdminRole[]}>>(
//       return this.http.post<BaseResponse<AdminRole[]>>(
//       this.baseAPIUrl + `/adminroles/list`, request, this.httpOptions
//     );
//   }

//   adminUserSetUp(msgData:AdminUser): any {

//     const request = msgData.Id? this.createBaseRequest(ConstantValues.UPDATE_ADMINUSER, msgData) : this.createBaseRequest('CREATE_ADMINUSER', msgData);

//     return this.http.post<BaseResponse<any>>(this.baseAPIUrl + `/adminusers/${msgData.Id? 'update' : 'create'}`, request, this.httpOptions);
//   }

//   loginAdminUser(msgData:LoginAdminUser){
//     const request = this.createBaseRequest(ConstantValues.LOGIN_ADMINUSER, msgData);

//     return this.http.post<BaseResponse<any>>(this.baseAPIUrl + '/adminusers/login', request, this.httpOptions);
//   }
// }

//#endregion